import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { AppContext } from '../../../app-context';
import IGridComponent from '../../../components/grid/i-grid.component';
import TitlePanel from '../../../components/title-panel/title-panel.component';
import { formatTo0Decimal, isEmptyArray } from '../../common/util.services';
import { getPurchase } from '../order.services';
import { Tooltip } from '@mui/material';
import { MATERIAL_SPECS_MAP } from '../../master-data/specs/specs.mapping';
import './order-purchase.component.scss';

const OrderPurchase = () => {
  const appContext = useContext(AppContext);
  const rows: GridRowsProp = [];
  const params = useParams();
  const orderId = params.orderId;
  const [purchaseData, setPurchaseData] = useState(rows);
  const popperProps = {sx: {'.MuiTooltip-tooltip': {bgcolor: 'ivory', fontSize: 16, color: 'black', border: 1}}};
  const columns: GridColDef[] = [
    { field: 'input', headerName: 'Input', filterable: false, sortable: false, editable: false, width: 80 },
    { field: 'code', headerName: 'Code', filterable: false, sortable: false, editable: false, width: 80 },
    { field: 'description', headerName: 'Description', filterable: false, sortable: false, editable: false, width: 120 },
    { 
      field: 'spec1', headerName: 'Spec 1', filterable: false, sortable: false, editable: false, width: 80,
      renderCell: (params: any) => (<Tooltip title={getTooltip(params.row.input, params.row.spec1, 0)} 
      PopperProps={popperProps}>{params.row.spec1}</Tooltip>)
    },
    { 
      field: 'spec2', headerName: 'Spec 2', filterable: false, sortable: false, editable: false, width: 80,
      renderCell: (params: any) =>  (<Tooltip title={getTooltip(params.row.input, params.row.spec2, 1)}
      PopperProps={popperProps}>{params.row.spec2}</Tooltip>)
    },
    { 
      field: 'spec3', headerName: 'Spec 3', filterable: false, sortable: false, editable: false, width: 80,
      renderCell: (params: any) =>  (<Tooltip title={getTooltip(params.row.input, params.row.spec3, 2)}
      PopperProps={popperProps}>{params.row.spec3}</Tooltip>)
    },
    { 
      field: 'spec4', headerName: 'Spec 4', filterable: false, sortable: false, editable: false, width: 80,
      renderCell: (params: any) =>  (<Tooltip title={getTooltip(params.row.input, params.row.spec4, 3)}
      PopperProps={popperProps}>{params.row.spec4}</Tooltip>)
    },
    { 
      field: 'spec5', headerName: 'Spec 5', filterable: false, sortable: false, editable: false, width: 80,
      renderCell: (params: any) =>  (<Tooltip title={getTooltip(params.row.input, params.row.spec5, 4)}
      PopperProps={popperProps}>{params.row.spec5}</Tooltip>)
    },
    { 
      field: 'spec6', headerName: 'Spec 6', filterable: false, sortable: false, editable: false, width: 80,
      renderCell: (params: any) =>  (<Tooltip title={getTooltip(params.row.input, params.row.spec6, 5)}
      PopperProps={popperProps}>{params.row.spec6}</Tooltip>)
    },
    { 
      field: 'spec7', headerName: 'Spec 7', filterable: false, sortable: false, editable: false, width: 80,
      renderCell: (params: any) =>  (<Tooltip title={getTooltip(params.row.input, params.row.spec7, 6)}
      PopperProps={popperProps}>{params.row.spec7}</Tooltip>)
    },
    { 
      field: 'spec8', headerName: 'Spec 8', filterable: false, sortable: false, editable: false, width: 80,
      renderCell: (params: any) =>  (<Tooltip title={getTooltip(params.row.input, params.row.spec8, 7)}
      PopperProps={popperProps}>{params.row.spec8}</Tooltip>)
    },
    { 
      field: 'spec9', headerName: 'Spec 9', filterable: false, sortable: false, editable: false, width: 80,
      renderCell: (params: any) =>  (<Tooltip title={getTooltip(params.row.input, params.row.spec9, 8)}
      PopperProps={popperProps}>{params.row.spec9}</Tooltip>)
    },
    { 
      field: 'spec10', headerName: 'Spec 10', filterable: false, sortable: false, editable: false, width: 80,
      renderCell: (params: any) =>  (<Tooltip title={getTooltip(params.row.input, params.row.spec10, 9)}
      PopperProps={popperProps}>{params.row.spec10}</Tooltip>)
    },
    { 
      field: 'spec11', headerName: 'Spec 11', filterable: false, sortable: false, editable: false, width: 80,
      renderCell: (params: any) =>  (<Tooltip title={getTooltip(params.row.input, params.row.spec11, 10)}
      PopperProps={popperProps}>{params.row.spec11}</Tooltip>)
    },
    { 
      field: 'spec12', headerName: 'Spec 12', filterable: false, sortable: false, editable: false, width: 80,
      renderCell: (params: any) =>  (<Tooltip title={getTooltip(params.row.input, params.row.spec12, 11)}
      PopperProps={popperProps}>{params.row.spec12}</Tooltip>)
    },
    { field: 'consumption', headerName: 'Quantity', filterable: false, sortable: false, editable: false, width: 75,
      valueFormatter: (consumption: any) => formatTo0Decimal(consumption)
    },
    { field: 'uom', headerName: 'UOM', filterable: false, sortable: false, editable: false, width: 70 },
  ];
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isEmptyArray(rows)) {
      getPurchase(orderId, appContext,
        (response: any) => {
          setPurchaseData(response.data);
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  }, []);

  function getTooltip (input: string, spec: string, index: number) {
    return MATERIAL_SPECS_MAP[input][index].fieldName + ': ' + spec;
  }

  const getMainPanel = () => {
    return <>
      <IGridComponent title={''} rows={purchaseData} columns={columns} loading={loading} maxHeight={450} hideFooterPagination={true}
        showAddBtn={false} showApproveAction={false} showDeleteAction={false} showUpAction={false} showDownAction={false}
        getRowId={(row: any) => row.id} hideFooter={true}/>
    </>
  }

  return <TitlePanel title='Material Purchase' panelBody={getMainPanel()} />
}

export default OrderPurchase;